const showNotificationReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default showNotificationReducer;